export default __webpack_public_path__ + "static/media/SFProText-Bold-1.9dae2991.ttf";